<h1 mat-dialog-title>{{ data.notification.Title }}</h1>
<div mat-dialog-content>
    <p class="notification-content">{{ data.notification.Content }}</p>
    <p *ngIf="data.notification.Type?.value === 'link'" class="notification-link">
        <a [href]="data.notification.NotificationsLink" target="_blank">Apri link</a>
    </p>
    <small class="notification-date">{{ data.notification.SentDate | date: 'dd/MM/yyyy HH:mm' }}</small>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="close()">Chiudi</button>
</div>
